module.exports = __webpack_public_path__ + "img/pr-3.5b7846c9.png";